import moment from 'moment';



 


        class Property{
         constructor(params,o){
          this.id = o.id;
          this.filter = (o.filter) ? o.filter : false;
          this.accountType = "Property";
            this._types = {
               
                
            }
            this.generic = {
              name:"",
              id:"",
              platformId:"",
              customerId:"",
              loginCustomerId:false,
              description:"",
              subTitle:"",
              accountType:"Property"
            }
               
               
            this.setParameters(o);
               

            for (var t of  Object.keys(this._types)){
             if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
               for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                 if (pt.objectIds.indexOf(this.id) > -1){
                   for (var oid of pt.pivotObjectIds){
                     if ((params.accounts[pt.pivotAccountId] && params.accounts[pt.pivotAccountId][oid]) && (!this.filter || (this.filter && this.filter[pt.pivotAccountId] && this.filter[pt.pivotAccountId].indexOf(oid) > -1))) {
                       params.accounts[pt.pivotAccountId][oid].filter = (this.filter) ? this.filter : false;
                       params.accounts[pt.pivotAccountId][oid].truncate = (this.truncate) ? this.truncate : false;
                       if (pt.originAccountId == this.originAccountId){
                        
                        var acs = params.accounts[pt.pivotAccountId][oid];
                            acs.originId = pt.originId;
                            acs.originAccountId = pt.originAccountId;
                            params.accounts[pt.pivotAccountId][oid].originAccountId = this.id;
                        var model = new this._types[t](params,acs);
                     if (!model.filtered){
                     this.setModelParameters(model);
                     }
                    }
                     }
                   }
                 }
             }
           }
           }
         
           
   }



             setParameters(params){
               for (var prop in params){
                   if (params.hasOwnProperty(prop)){
                       var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                       if (this[method]){
                         this[method](params[prop]);
                       }
                       
                   }
               }

           }

         
             
           setId(id){
               this.id = id;
               this.generic.id = id;
         }


       setName(str){
         this.generic.name = (this.generic.name == "") ? str : str + " - " + this.generic.name;
       }
       setPropertyAddress(add){
        this.generic.description = add;
       }
      setStoreCode(str){
       this.generic.subTitle = str;
       
     }
     setStoreInformation(obj){
      this.storeInformation = JSON.parse(obj);
    }
   
    setOriginAccountId(id){
      this.originAccountId = id;
      this.generic.originAccountId = id;
    }
    setOriginId(id){
      this.originId = id;
      this.generic.originId = id;
    }
     setPhoneNumbers(str){
      this.generic.label = str;
     }

       setPlatformId(str){
         this.generic.platformId = str;
         this.generic.name = (this.generic.name == "") ? str : this.generic.name + "-" + str;
       }

        
    
           
       

       setTruncate(obj){
        if (obj){
        this.truncate = obj;
        this.filtered = (obj && obj[this.accountType] && (obj[this.accountType].indexOf(this.id) > -1)) ? false : true;
        }
      }
         
         
       
       setModelParameters(params){
           this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
           this[params.accountType].push(params);
       }
     }
export default Property;
        